// For those Local* mixins.
import './location';
import './user';

import debug from 'debug';

const d = debug('a7-resources-common:model:init');

d('initialize resources common');
